import { z } from "zod";
var PillType = /* @__PURE__ */ ((PillType2) => {
  PillType2["Neutral"] = "neutral";
  PillType2["Success"] = "success";
  PillType2["Danger"] = "danger";
  PillType2["Warning"] = "warning";
  PillType2["Info"] = "info";
  return PillType2;
})(PillType || {});
const normalizePillType = (type) => {
  const lowerType = type.toLowerCase();
  const aliases = {
    "warn": "warning" /* Warning */,
    "warning": "warning" /* Warning */,
    "info": "info" /* Info */,
    "information": "info" /* Info */,
    "neutral": "neutral" /* Neutral */,
    "success": "success" /* Success */,
    "danger": "danger" /* Danger */
  };
  if (aliases[lowerType]) {
    return aliases[lowerType];
  }
  const validTypes = Object.values(PillType);
  const foundType = validTypes.find((validType) => validType === type);
  return foundType || "neutral" /* Neutral */;
};
const toBooleanFromPresence = (val) => val === true || typeof val === "string" && val !== void 0;
const attributesPillSchema = z.object({
  type: z.string().transform(normalizePillType).optional(),
  danger: z.union([z.boolean(), z.string()]).transform(toBooleanFromPresence).optional(),
  warning: z.union([z.boolean(), z.string()]).transform(toBooleanFromPresence).optional(),
  warn: z.union([z.boolean(), z.string()]).transform(toBooleanFromPresence).optional(),
  success: z.union([z.boolean(), z.string()]).transform(toBooleanFromPresence).optional(),
  info: z.union([z.boolean(), z.string()]).transform(toBooleanFromPresence).optional(),
  information: z.union([z.boolean(), z.string()]).transform(toBooleanFromPresence).optional(),
  neutral: z.union([z.boolean(), z.string()]).transform(toBooleanFromPresence).optional(),
  class: z.string().optional()
});
export {
  PillType,
  attributesPillSchema,
  normalizePillType
};
//# sourceMappingURL=attributes.js.map
